// extracted by mini-css-extract-plugin
export var radioInputRow = "w_rY";
export var radioInputColumn = "w_rZ";
export var inputOptionRow = "w_pw";
export var inputOptionColumn = "w_px";